// extracted by mini-css-extract-plugin
module.exports = {"actionContainer":"Pricetemplates_actionContainer__KNjuq","pricetemplatesLayout":"Pricetemplates_pricetemplatesLayout__cNG8o"};